import { createTheme, responsiveFontSizes } from '@mui/material/styles';

// Se cambia a 'let' para permitir que responsiveFontSizes lo modifique
let theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#BFDBFE', // Azul Cielo Tecnológico (muy claro)
      contrastText: '#1E3A8A', // Un azul oscuro para el texto sobre el color primario
    },
    secondary: {
      main: '#94A3B8', // Gris Acero (para acentos y elementos secundarios)
      contrastText: '#FFFFFF', // Texto blanco sobre el color secundario
    },
    background: {
      default: '#F8FAFC', // Fondo general casi blanco, con un toque frío
      paper: '#FFFFFF',   // Fondo para elementos elevados como tarjetas o menús
    },
    text: {
      primary: '#0F172A', // Gris Pizarra Oscuro (casi negro, pero más suave)
      secondary: '#475569', // Gris Pizarra más claro para textos secundarios
    },
  },
  typography: {
    fontFamily: 'Inter, Roboto, Arial, sans-serif', // 'Inter' es una excelente fuente para interfaces tech
    
    // Se definen los tamaños de fuente base para escritorio.
    // responsiveFontSizes los escalará hacia abajo para pantallas más pequeñas.
    h1: {
      fontWeight: 700,
      fontSize: '4.5rem',
    },
    h2: {
      fontWeight: 700,
      fontSize: '3.5rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '2.5rem',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.75rem',
    },
    h5: {
      fontWeight: 500,
      fontSize: '1.5rem',
    },
    h6: {
      fontWeight: 500,
      fontSize: '1.25rem',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 'bold',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
  },
});

// Se exporta el tema envuelto en la función para hacerlo responsivo
export default responsiveFontSizes(theme);